import 'core-js'
import React from 'react';
import ReactDOM from 'react-dom';
//import registerServiceWorker from './registerServiceWorker';
import {unregister} from './registerServiceWorker';
import App from './App';
import './index.css';

const target= document.getElementById('root');

ReactDOM.render( <App/>, target )

//registerServiceWorker();
// Tuan: I decided to remove service worker, and therefor also need to unregister
// any of the serivce worker that is running in client side
unregister();



// WEBPACK FOOTER //
// ./src/index.js